import { useState } from 'react';

import { useMsal } from "@azure/msal-react";
import { notification } from 'antd';

import { ProductBusinessUnit } from '../../../../api-client';
import { CustomerApiClient } from '../../../../providers/api-provider';
import { validateCustomer } from '../../../../utils/axios-helpers/request-validation-helper';

export const useProductsType = () => {
    const {
        instance
    } = useMsal();

    const [productTypes, setProductTypes] = useState<ProductBusinessUnit[]>();
    const [productTypesLoading, setProductTypesLoading] = useState<boolean>(false);

    const handleProductTypes = async (id: number = -1) => {
        setProductTypesLoading(true);

        validateCustomer(id);

        const clientApi = await CustomerApiClient(instance);

        clientApi.getCustomerBusinessUnits(id)
            .then((response) => {
                setProductTypes(response.data);
            })
            .catch((reason) => {
                setProductTypes([]);

                notification.error({
                    message: 'Unable to retrieve business units!',
                    description: 'Unable to retrieve business units.',
                    duration: 2
                });
            })
            .finally(() => {
                setProductTypesLoading(false);
            });
    }

    return {
        handleProductTypes,
        productTypes,
        productTypesLoading
    }
}